import { FC, LabelHTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';

type InputLabelProps = LabelHTMLAttributes<HTMLLabelElement> &
    PropsWithChildren<{
        value: string | ReactNode;
    }>;

export const InputLabel: FC<InputLabelProps> = ({
    value,
    className = '',
    children,
    ...props
}) => {
    return (
        <label
            {...props}
            aria-label={typeof value === 'string' ? value : undefined}
            role="note"
            className={classNames(
                `block font-medium text-brand-blue`,
                className,
            )}>
            {value ? value : children}
        </label>
    );
};
